/* =========================================================================
   "Will it fit?" pop-up on the product page.

   The fit box (print size / mat opening / outer size) used to sit between
   the options and Add to cart. It now lives in a pop-up opened from a link
   beside the SIZE heading. The box keeps its markup, so af-main-product.js
   still updates it when the shopper changes size.

   The link hides whenever the box has nothing to show (sets, variants with
   no sizing data), mirroring the box's own `hidden` attribute.
   ========================================================================= */
(function () {
  'use strict';

  function init(root) {
    var modal = root.querySelector('[data-af-fit-modal]');
    var triggers = root.querySelectorAll('[data-af-fit-open]');
    if (!triggers.length) return;
    var fit = modal && modal.querySelector('[data-af-fit]');

    function sync() {
      var off = !fit || fit.hidden;
      for (var i = 0; i < triggers.length; i++) triggers[i].hidden = off;
    }
    sync();
    if (!fit) return;
    new MutationObserver(sync).observe(fit, { attributes: true, attributeFilter: ['hidden'] });

    var opener = null;
    var closeBtn = modal.querySelector('.af-fit-modal__close');

    function open(e) {
      opener = e.currentTarget;
      modal.hidden = false;
      document.documentElement.classList.add('af-fit-open');
      if (closeBtn) closeBtn.focus();
      /* Counted so we can see how many shoppers open it now that the numbers
         are behind a click. */
      if (typeof window.afTrack === 'function') {
        try { window.afTrack('fit_popup_open', { placement: 'pdp_size' }); } catch (err) { /* ignore */ }
      }
    }
    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('af-fit-open');
      if (opener) opener.focus();
    }

    for (var i = 0; i < triggers.length; i++) triggers[i].addEventListener('click', open);
    var closers = modal.querySelectorAll('[data-af-fit-close]');
    for (var j = 0; j < closers.length; j++) closers[j].addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  var roots = document.querySelectorAll('[data-af-product-root]');
  for (var r = 0; r < roots.length; r++) init(roots[r]);
})();
